import React from "react";
import { Modal } from "reactstrap";

export default function ViewCampaignModal({ isOpen, toggle ,setViewCampaignModal}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <div
        style={{
          padding: "1.5rem",
          display: "flex",
          flexDirection: "column",
          gap: "1.25rem",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #ddd",
            paddingBottom: "0.75rem",
          }}
        >
          <h5 style={{ margin: 0, fontWeight: "600" }}>View Campaign</h5>
          <button
            onClick={(()=>{setViewCampaignModal(false)})}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "1.25rem",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        {/* Details Section */}
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" ,marginBottom:70}}>
          {[
            ["Campaign Title", "The Best Campaign Ever"],
            ["Type", "Banner Brush"],
            ["Status", "Active"],
            ["Start Date", "Sept 20, 2023"],
            ["End Date", "Sept 30, 2023"],
            ["Last Mdofied By", "John Doe"],
          ].map(([label, value], idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ fontWeight: "500" }}>{label}</span>
              <span>{value}</span>
            </div>
          ))}
        </div>

        {/* Footer */}
        {/* <div
          style={{
            borderTop: "1px solid #ddd",
            paddingTop: "0.75rem",
            fontSize: "0.9rem",
            color: "#555",
          }}
        >
          Last Modified By: <strong>Gabriel Israel</strong>
        </div> */}
      </div>
    </Modal>
  );
}
